var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('Title',{attrs:{"num":_vm.num,"time":_vm.time,"title":_vm.title}}),_vm._v(" "),_c('div',{class:_vm.$style.content},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }